<template>
    <div>
        <v-card max-width="700" min-width="500">
            <v-card-title>{{ "Integration info" | t }}</v-card-title>

            <v-card-text>
                <v-row class="align-baseline" no-gutters>
                    <v-col class="subtitle-1" cols="3">{{ "Client ID" | t }}</v-col>
                    <v-col cols="6"
                        ><span class="subtitle-0">
                            {{ activeCompany.client_id ? activeCompany.client_id : "-" }}
                        </span></v-col
                    >
                    <v-col>
                        <v-btn v-if="this.$route.params.companyId !== 'new'" small @click="handleGenerateNewClientId"
                            >{{ "Generate" | t }}
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="align-baseline mt-1 mb-2" no-gutters>
                    <v-col v-if="this.$route.params.companyId !== 'new'" class="subtitle-1" cols="3"
                        >{{ "API key" | t }}
                    </v-col>
                    <v-col cols="3">
                        <v-text-field
                            v-if="apiKey"
                            id="clipboardToCopy"
                            :value="apiKey"
                            class="subtitle-2"
                            dense
                            hide-details
                            outlined
                        />
                    </v-col>
                    <v-col>
                        <v-btn v-if="apiKey" class="ml-2" small @click="copyApiInput">{{ "Copy" | t }}</v-btn>
                    </v-col>
                    <v-col>
                        <v-btn v-if="this.$route.params.companyId !== 'new'" small @click="handleGenerateNewApiKey"
                            >{{ "Generate new" | t }}
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row class="align-baseline mt-1 mb-2" no-gutters>
                    <v-col class="subtitle-1" cols="6"
                    >{{ "Include payer IBAN to postback" | t }}
                    </v-col>
                    <v-col cols="3">
                        <v-switch
                                v-model="activeCompany.meta.postback.payer_iban"
                                @change="updateMetaPostbackField($event, 'payer_iban')"
                                :label="`${activeCompany.meta.postback.payer_iban ? 'Yes' : 'No'}`"
                        />
                    </v-col>
                </v-row>
                <v-row class="align-baseline mt-1 mb-2" no-gutters>
                    <v-col class="subtitle-1" cols="6"
                    >{{ "Include payer name to postback" | t }}
                    </v-col>
                    <v-col cols="3">
                        <v-switch
                                v-model="activeCompany.meta.postback.payer_name"
                                @change="updateMetaPostbackField($event, 'payer_name')"
                                :label="`${activeCompany.meta.postback.payer_name ? 'Yes' : 'No'}`"
                        />
                    </v-col>
                </v-row>
                <v-form v-model="formValidation">
                    <div v-for="(item, index) in activeCompanyBanks" :key="item.bank_id">
                        <div v-if="item.name === 'Stripe'">
                            <v-divider class="mt-3 mb-3"/>
                            <v-row>
                                <v-col class="pt-0 pb-0">
                                    <v-checkbox
                                        v-model="item.is_active"
                                        @input="updateBankField($event, 'is_active', index)"
                                        :label="`${!item.is_active ? 'Activate' : 'Deactivate'} Stripe payment method`"
                                    />
                                </v-col>
                            </v-row>
                            <div v-if="item.is_active">
                                <v-row>
                                    <v-col class="subtitle-1">{{ item.name }} {{ "public key" | t }}:</v-col>
                                    <v-col class="col-item" cols="6">
                                        <v-text-field
                                            :rules="[rules.required]"
                                            :value="item.public_key"
                                            class="text-field-item mb-1"
                                            dense
                                            hide-details
                                            outlined
                                            @input="updateBankField($event, 'public_key', index)"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="subtitle-1">
                                    <v-col>{{ item.name }} {{ "secret key" | t }}:</v-col>
                                    <v-col class="col-item" cols="6">
                                        <v-text-field
                                            :rules="[rules.required]"
                                            :value="item.secret_key"
                                            class="text-field-item mb-1"
                                            dense
                                            hide-details
                                            outlined
                                            @input="updateBankField($event, 'secret_key', index)"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="subtitle-1">
                                    <v-col>{{ item.name }} {{ "recipient name" | t }}:</v-col>
                                    <v-col class="col-item" cols="6">
                                        <v-text-field
                                            :rules="[rules.required]"
                                            :value="item.recipient_name"
                                            class="text-field-item mb-1"
                                            dense
                                            hide-details
                                            outlined
                                            @input="updateBankField($event, 'recipient_name', index)"
                                        />
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                        <div v-else-if="item.name === 'Placet'">
                            <div v-if="user.role === 'admin'">
                                <v-divider class="mt-3 mb-3"/>

                                <v-row>
                                    <v-col class="pt-0 pb-0">
                                        <v-checkbox
                                            v-model="item.is_active"
                                            @input="updateBankField($event, 'is_active', index)"
                                            :label="
                                                `${!item.is_active ? 'Activate' : 'Deactivate'} Placet payment method`
                                            "
                                        />
                                    </v-col>
                                </v-row>
                                <div v-if="item.is_active">
                                    <v-row>
                                        <v-col class="subtitle-1">{{ item.name }} {{ "partner key" | t }}:</v-col>
                                        <v-col class="col-item" cols="6">
                                            <v-text-field
                                                :rules="[rules.required]"
                                                :value="item.partner_key"
                                                class="text-field-item mb-1"
                                                dense
                                                hide-details
                                                outlined
                                                @input="updateBankField($event, 'partner_key', index)"
                                            />
                                        </v-col>
                                    </v-row>

                                    <v-row class="subtitle-1">
                                        <v-col>{{ item.name }} {{ "recipient name" | t }}:</v-col>
                                        <v-col class="col-item" cols="6">
                                            <v-text-field
                                                :rules="[rules.required]"
                                                :value="item.recipient_name"
                                                class="text-field-item mb-1"
                                                dense
                                                hide-details
                                                outlined
                                                @input="updateBankField($event, 'recipient_name', index)"
                                            />
                                        </v-col>
                                    </v-row>
                                </div>
                            </div>
                        </div>
                        <div v-else>
                            <v-divider class="mt-3 mb-3"/>
                            <v-row>
                                <v-col class="pt-0 pb-0">
                                    <v-checkbox
                                        v-model="item.is_active"
                                        @input="updateBankField($event, 'is_active', index)"
                                        :label="
                                            `${!item.is_active ? 'Activate' : 'Deactivate'} ${item.name} ${
                                                item.country
                                            } (${item.swift})`
                                        "
                                    />
                                </v-col>
                            </v-row>
                            <div v-if="item.is_active">
                                <v-row>
                                    <v-col class="subtitle-1"
                                        >{{ `${item.name} ${item.country} ${t("recipient IBAN")}:` }}
                                    </v-col>
                                    <v-col class="col-item" cols="6">
                                        <v-text-field
                                            :rules="[rules.ibanRule]"
                                            :value="item.recipient_iban"
                                            class="text-field-item mb-1"
                                            dense
                                            hide-details
                                            outlined
                                            @input="updateBankField($event, 'recipient_iban', index)"
                                        />
                                    </v-col>
                                </v-row>
                                <v-row class="subtitle-1">
                                    <v-col>{{ `${item.name} ${item.country} ${t("recipient name")}:` }}</v-col>
                                    <v-col class="col-item" cols="6">
                                        <v-text-field
                                            :value="item.recipient_name"
                                            class="text-field-item mb-1"
                                            :rules="[rules.required]"
                                            dense
                                            hide-details
                                            outlined
                                            @input="updateBankField($event, 'recipient_name', index)"
                                        />
                                    </v-col>
                                </v-row>
                            </div>
                        </div>
                    </div>
                </v-form>
            </v-card-text>

            <v-divider class="mt-4 mb-4" />
            <v-card-title>
                <span class="mr-1">{{ "Access origin" | t }}</span>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon color="grey" dark v-bind="attrs" v-on="on">
                            mdi-information
                        </v-icon>
                    </template>
                    <span>{{
                        "Insert your company domains where your application will be used. It is necessary if you are using embed version of our application."
                            | t
                    }}</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text>
                <v-row v-for="(url, idx) in activeCompanyOrigins" :key="url" class="align-baseline" no-gutters>
                    <v-col>
                        <v-text-field
                            :value="url"
                            :placeholder="appUrl"
                            class="text-field-item mb-1 mt-2"
                            dense
                            hide-details
                            outlined
                            @input="updateOriginField($event, idx)"
                        />
                    </v-col>
                    <v-col :cols="1" style="text-align: center">
                        <v-icon @click="handleOriginDeleteClick(idx)">delete</v-icon>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer />
                    <v-btn class="mr-3 mt-1" small @click="handleOriginAddClick">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-row>
            </v-card-text>

            <v-divider class="mt-4 mb-4" />
            <v-card-title>
                <span class="mr-1">{{ "Allowed IBANs" | t }}</span>
                <v-tooltip top>
                    <template v-slot:activator="{ on, attrs }">
                        <v-icon color="grey" dark v-bind="attrs" v-on="on">
                            mdi-information
                        </v-icon>
                    </template>
                    <span>{{
                        "Allow IBANs for API calls and CSV importer. It is necessary if you are using CSV importer." | t
                    }}</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text>
                <v-row v-for="(iban, idx) in activeCompanyAllowedIbans" :key="iban" class="align-baseline" no-gutters>
                    <v-col>
                        <v-form v-model="allowedIbanValidation">
                            <v-text-field
                                :rules="[rules.ibanRule]"
                                :value="iban"
                                placeholder="EE381010220196205220"
                                class="text-field-item mb-1 mt-2"
                                dense
                                hide-details
                                outlined
                                @input="updateAllowedIbanField($event, idx)"
                            />
                        </v-form>
                    </v-col>
                    <v-col :cols="1" style="text-align: center">
                        <v-icon @click="handleAllowedIbanDeleteClick(idx)">delete</v-icon>
                    </v-col>
                </v-row>
                <v-row>
                    <v-spacer />
                    <v-btn class="mr-3 mt-1" small @click="handleAllowedIbanAddClick">
                        <v-icon>add</v-icon>
                    </v-btn>
                </v-row>
            </v-card-text>
            <v-card-actions>
                <v-spacer />
                <v-btn
                    color="black"
                    text
                    :disabled="!formValidation || !allowedIbanValidation"
                    @click="handleSaveClick"
                >
                    {{ "Save" | t }}
                </v-btn>
            </v-card-actions>
        </v-card>
        <v-snackbar v-model="copy_message" :timeout="2500" bottom color="success" elevation="24" right value="true">
            <div style="display: flex">
                <v-icon color="#FFF">check</v-icon>
                <div class="title pa-2 ">{{ "Successfully copied" | t }}</div>
            </div>
        </v-snackbar>
    </div>
</template>

<script>
import {mapActions, mapMutations, mapState} from "vuex";
import Store from "@/store";
import IBAN from "iban";
import settings from "../../../settings";

export default {
    name: "integration-edit-card",
    computed: {
        ...mapState([
            "activeCompany",
            "activeCompanyBanks",
            "apiKey",
            "activeUser",
            "activeCompanyOrigins",
            "activeCompanyAllowedIbans",
            "user"
        ])
    },
    mounted() {
        if (this.activeUser && this.activeUser.company_role !== "owner") {
            this.$router.push({
                name: "settings-view"
            });
        }
    },
    data() {
        return {
            copy_message: false,
            formValidation: false,
            rules: {
                required: value => !!value || "Required.",
                ibanRule: value => {
                    return IBAN.isValid(value) || "Invalid IBAN.";
                }
            },
            appUrl: settings.api_url,
            allowedIbanValidation: true
        };
    },
    destroyed() {
        Store.commit("setApiKey", null);
    },
    methods: {
        ...mapMutations(['setActiveCompanyMetaPostbackProperty']),
        ...mapActions([
            "submitCompanyUpdate",
            "generateNewApiKey",
            "generateNewClientId",
            "getCompanyData",
            "getUserData"
        ]),
        async handleSaveClick() {
            const response = await this.submitCompanyUpdate({
                company: this.activeCompany,
                banks: this.activeCompanyBanks,
                origins: this.activeCompanyOrigins,
                allowed_ibans: this.activeCompanyAllowedIbans
            });
            if (response && response.status === 1) {
                await this.$router.push({
                    name: "settings-view"
                });
                if (this.activeUser.company_id) {
                    await this.getCompanyData(this.activeUser.company_id);
                }
                await Store.commit("setRequestSuccess", true);
            } else {
                await Store.commit("setRequestError", true);
                await Store.commit("setErrorMessage", "Failed");
            }
        },
        async handleGenerateNewClientId() {
            await this.generateNewClientId(this.activeCompany.id);
        },
        async handleGenerateNewApiKey() {
            await this.generateNewApiKey(this.activeCompany.id);
            document.execCommand("copy");
            this.copy_message = true;
        },
        updateBankField(value, field, index) {
            Store.commit("updateActiveCompanyBankProperty", { prop: field, value: value, index: index });
        },
        updateMetaPostbackField(value, field) {
            this.setActiveCompanyMetaPostbackProperty({ prop: field, value: value });
        },
        copyApiInput() {
            let copyText = document.querySelector("#clipboardToCopy");
            copyText.select();
            copyText.setSelectionRange(0, 99999);
            document.execCommand("copy");
            this.copy_message = true;
        },
        handleOriginAddClick() {
            Store.commit("addNewCompanyOrigin");
        },
        handleOriginDeleteClick(index) {
            Store.commit("deleteCompanyOrigin", { index: index });
        },
        updateOriginField(value, index) {
            Store.commit("updateActiveCompanyOriginProperty", { value: value, index: index });
        },
        handleAllowedIbanAddClick() {
            Store.commit("addNewCompanyAllowedIban");
        },
        handleAllowedIbanDeleteClick(index) {
            Store.commit("deleteCompanyAllowedIban", { index: index });
        },
        updateAllowedIbanField(value, index) {
            Store.commit("updateActiveCompanyAllowedIbanProperty", { value: value, index: index });
        }
    }
};
</script>

<style scoped>
.col-item {
    padding-top: 4px;
    padding-bottom: 4px;
}
</style>
